import { useState } from 'react';

import type { BillingData } from '../domain-types';

export function useBilling() {
  const [billingData, setBillingData] = useState<BillingData | null>(null);
  const [billingContactName, setBillingContactName] = useState('');
  const [billingEmail, setBillingEmail] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [billingBusy, setBillingBusy] = useState(false);
  const [giftDurationDays, setGiftDurationDays] = useState(30);
  const [giftReason, setGiftReason] = useState('Complimentary quality.vet access');
  return {
    billingData,
    setBillingData,
    billingContactName,
    setBillingContactName,
    billingEmail,
    setBillingEmail,
    billingAddress,
    setBillingAddress,
    billingBusy,
    setBillingBusy,
    giftDurationDays,
    setGiftDurationDays,
    giftReason,
    setGiftReason,
  };
}
